module.exports = __webpack_public_path__ + "img/flying.e6d59d05.png";